import React, { useState, useEffect } from 'react';
import { Link, Routes, Route } from 'react-router-dom';
import SetupCourse from './SetupCourse';
import UploadVideo from './UploadVideo';
import UploadPDF from './UploadPDF';
import SetupQuiz from './SetupQuiz';
import ManageCategories from './ManageCategories'; // Import the new ManageCategories component
import ManageAccessCodes from './ManageAccessCodes'; // Import the new ManageAccessCodes component
import UploadDemo from './uploadDemo'; // Import the UploadDemo component

const AdminDashboard = () => {
  const [courses, setCourses] = useState([]);
  const [selectedCourse, setSelectedCourse] = useState(null);
  const [pdfs, setPdfs] = useState([]);
  const [viewingPdf, setViewingPdf] = useState(null); // To track the PDF being viewed

  // Fetch courses from the backend
  useEffect(() => {
    fetch('https://schoolofservice.co.za/backend/get-courses.php')
      .then((response) => response.json())
      .then((data) => setCourses(data))
      .catch((error) => console.error('Error fetching courses:', error));
  }, []);

  // Fetch PDFs when a course is selected
  useEffect(() => {
    if (selectedCourse) {
      fetch(`https://schoolofservice.co.za/backend/get-pdfs.php?courseId=${selectedCourse}`)
        .then((response) => response.json())
        .then((data) => setPdfs(data))
        .catch((error) => console.error('Error fetching PDFs:', error));
    }
  }, [selectedCourse]);

  return (
    <div className="d-flex">
      <div className="d-flex flex-column bg-light" style={{ width: '250px', height: '100vh' }}>
        <h3 className="text-center py-3">Admin Panel</h3>
        <div className="d-flex flex-column">
          <Link to="/admin/setup-course" className="btn btn-outline-primary m-2">Setup Course</Link>
          <Link to="/admin/upload-video" className="btn btn-outline-primary m-2">Upload Video</Link>
          <Link to="/admin/uploadDemo" className="btn btn-outline-primary m-2">Upload Demo Video</Link>
          <Link to="/admin/upload-pdf" className="btn btn-outline-primary m-2">Upload PDFs</Link>
          <Link to="/admin/setup-quiz" className="btn btn-outline-primary m-2">Set Up Quiz</Link>
          <Link to="/admin/manage-categories" className="btn btn-outline-primary m-2">Manage Categories</Link>
          <Link to="/admin/manage-access-codes" className="btn btn-outline-primary m-2">Manage Access Codes</Link>
          <Link to="/logout" className="btn btn-outline-danger m-2">Logout</Link>
        </div>
      </div>

      <div className="container py-5" style={{ flexGrow: 1 }}>
        <Routes>
          <Route
            path="/"
            element={
              <>
                <h2>Welcome to the Admin Dashboard</h2>
                <div>
                  <h4>Select a Course</h4>
                  <div className="d-flex flex-wrap">
                    {courses.map((course) => (
                      <button
                        key={course.coursesID} // Ensure key is unique
                        className="btn btn-outline-primary m-2"
                        onClick={() => setSelectedCourse(course.coursesID)}
                      >
                        {course.courseName}
                      </button>
                    ))}
                  </div>
                </div>
                {selectedCourse && (
                  <>
                    <div className="d-flex flex-wrap">
                      {pdfs.length > 0 ? (
                        pdfs.map((pdf) => (
                          <div key={pdf.pdfId || pdf.fileName} className="card m-2" style={{ width: '18rem' }}>
                            <div className="card-body">
                              <h5 className="card-title">{pdf.fileName}</h5>
                              <button
                                onClick={() => setViewingPdf(`/uploads/pdfs/${pdf.fileName}`)}
                                className="btn btn-primary"
                              >
                                View PDF
                              </button>
                              <a
                                href={`https://schoolofservice.co.za/uploads/pdfs/${pdf.fileName}`}
                                download={pdf.fileName}
                                className="btn btn-secondary ms-2"
                              >
                                Download PDF
                              </a>
                            </div>
                          </div>
                        ))
                      ) : (
                        <p>No PDFs uploaded for this course yet.</p>
                      )}
                    </div>
                  </>
                )}
                {viewingPdf && (
                  <div className="mt-4">
                    <h4>Viewing PDF</h4>
                    <embed
                      src={`https://schoolofservice.co.za/uploads/pdfs/${viewingPdf}`}
                      type="application/pdf"
                      width="100%"
                      height="600px"
                      aria-label="PDF Viewer"
                    />
                  </div>
                )}
              </>
            }
          />
          <Route path="setup-course" element={<SetupCourse />} />
          <Route path="upload-video" element={<UploadVideo />} />
          <Route path="uploadDemo" element={<UploadDemo />} />
          <Route path="upload-pdf" element={<UploadPDF />} />
          <Route path="setup-quiz" element={<SetupQuiz />} />
          <Route path="manage-categories" element={<ManageCategories />} /> {/* Add the route for Manage Categories */}
          <Route path="manage-access-codes" element={<ManageAccessCodes />} /> {/* Add the route for Manage Access Codes */}
        </Routes>
      </div>
    </div>
  );
};

export default AdminDashboard;
